import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { getPrimaryDms, normalizeDms, sortIndividualDms } from './utils';

export type DecisionMaker = {
	id: string;
	displayName: string;
	slug: string | null;
	title: string | null;
	location: string | null;
	photoUrl: string | null;
	signersText: string;
	constituentCount: string | null | undefined;
	publiclyVisible: boolean;
	response?: string;
};

export type LegislativeBody = {
	title: string;
	location: string | null;
	signersText: string;
	displayedDMs: readonly DecisionMaker[];
	displayViewMoreButton: boolean;
};

type Result = ModelHookResult<{
	primaryDMs: DecisionMaker[] | [];
	legislativeBodies: LegislativeBody[];
	displayViewAllButton: boolean;
}>;

const DISPLAYED_DM_COUNT = 3;

export function useDecisionMakers(): Result {
	const {
		data: {
			petition: {
				primaryDecisionMakerConnection: { nodes: dms },
				dmResponsesConnection: { nodes: allDmResponses },
			},
		},
	} = usePetitionDetailsPageData();

	const politiciansOnly = [...dms].filter((dm) => {
		return dm.type === 'POLITICIAN';
	});

	const allDms = normalizeDms(dms, [...allDmResponses]);

	const legislativeBodies = [
		{
			title: 'City Council',
			location: 'Arizona',
			signersText: '8 members representing 2,132 signers',
			decisionMakers: [...allDms],
		},
	];

	const primaryDmsList = getPrimaryDms(politiciansOnly);
	const normalizedPrimaryDMs = normalizeDms(primaryDmsList, [...allDmResponses]);
	const sortedPrimaryDMs = sortIndividualDms(normalizedPrimaryDMs);

	return {
		data: {
			primaryDMs: sortedPrimaryDMs,
			legislativeBodies: legislativeBodies.map(({ decisionMakers, ...rest }) => ({
				...rest,
				displayedDMs: decisionMakers.slice(0, DISPLAYED_DM_COUNT),
				displayViewMoreButton: decisionMakers.length > DISPLAYED_DM_COUNT,
			})),
			displayViewAllButton: true,
		},
	};
}
